import React, { useState, useEffect } from 'react';
import {
    Button, Card, CardHeader, Table, Container, Row, Col, Form, FormGroup, InputGroupAddon, InputGroupText, Input, InputGroup, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Modal, ModalHeader, ModalBody, Badge, Label,
    UncontrolledTooltip, UncontrolledDropdown, ModalFooter, Alert,
} from "reactstrap";
import { Link } from 'react-router-dom';
import { api } from "../../../../api";
import Cookies from 'js-cookie';
import { isEqual } from 'lodash';
import Tippy from '@tippyjs/react';

const Leave3 = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredData, setFilteredData] = useState([]);

    //Pagination code part 1
    const [leaveList, setLeaveList] = useState([]);
    const [dynamo, setDynamo] = useState([]);
    const [change, setChange] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);

    const [modal, setModal] = useState(false); // State to control modal visibility
    const [modalAdd, setModalAdd] = useState(false);
    const toggleModalAdd = () => setModalAdd(prevState => !prevState);
    const [clientForm, setClientForm] = useState({
        status: "",
        starting: "",
        ending: "",
        description: ""
    });

    const [dropdownOpen, setDropdownOpen] = useState({});
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
    const [deleteProjectName, setDeleteProjectName] = useState('');

    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    // const emp_id = 1;
    const emp_id = Cookies.get('emp_id');

    useEffect(() => {
        const fetchLeaveData = async () => {
            try {
                const company_id = Cookies.get('company_id');
                const response = await api.get(`hrleave.php?company_id=${company_id}`);
                if (response.status === 200) {
                    console.log("HR Leave data received:", response.data);
                    console.log("HR Roles in data:", response.data.map(item => ({ name: item.emp_name, role: item.role })));
                    setFilteredData(response.data);
                    setLeaveList(response.data);
                    setDynamo(response.data);
                    setChange(response.data);
                } else {
                    console.error("Failed to fetch leave data");
                }
            } catch (error) {
                console.error("Error fetching leave data:", error);
            }
        };

        fetchLeaveData();
    }, []); // Removed filteredData from dependency array

    if (isEqual(filteredData, leaveList)) {
        console.log('Correct', leaveList);
    }

    const filteredSearchData = Array.isArray(change) ?
        change.filter(item =>
            (item.leave_type || '').toLowerCase().includes(searchQuery.toLowerCase()) ||
            (item.emp_name || '').toLowerCase().includes(searchQuery.toLowerCase())
        ) :
        [];

    const toggleDropdown = (index) => {
        setDropdownOpen(prevState => ({
            ...prevState,
            [index]: !prevState[index]
        }));
    }


    const toggleModal = () => {
        setModal(!modal);
    };

    const statusOptions = [
        { "value": "Casual Leave", "label": "Casual Leave" },
        { "value": "Medical Leave", "label": "Medical Leave" },
        { "value": "Voting Leave", "label": "Voting Leave" },
        { "value": "Sabbatical Leave", "label": "Sabbatical Leave" },
        { "value": "Bereavement Leave", "label": "Bereavement Leave" },
        { "value": "Maternity Leave", "label": "Maternity Leave" },
        { "value": "Paternity Leave", "label": "Paternity Leave" },
        { "value": "Adoption Leave", "label": "Adoption Leave" },
        { "value": "Family Care Leave", "label": "Family Care Leave" },
        { "value": "Study Leave", "label": "Study Leave" },
        { "value": "Jury Duty Leave", "label": "Jury Duty Leave" },
        { "value": "Public Holiday Leave", "label": "Public Holiday Leave" },
        { "value": "Religious Holiday Leave", "label": "Religious Holiday Leave" }
    ];

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setClientForm(prevState => ({
            ...prevState,
            file: file
        }));
    };


    const handleStatusAction = async (id, status, e) => {
        e.preventDefault();
        const data = {
            id: id,
            status: status
        }
        try {
            const company_id = Cookies.get('company_id');
            const response = await api.post('hrleave.php', { ...data, company_id });
            console.log(response.data);
            
            // Show success message for status update
            setSuccessMessage(`Leave status updated to ${status} successfully!`);
            setShowSuccessAlert(true);
            
            // Refresh the data
            const fetchLeaveData = async () => {
                try {
                    const response = await api.get(`hrleave.php?company_id=${company_id}`);
                    if (response.status === 200) {
                        setFilteredData(response.data);
                        setLeaveList(response.data);
                        setDynamo(response.data);
                        setChange(response.data);
                    }
                } catch (error) {
                    console.error("Error fetching leave data:", error);
                }
            };
            fetchLeaveData();
        } catch (error) {
            console.error('Error updating status:', error);
            setErrorMessage('Failed to update leave status. Please try again.');
        }
    };

    const [leaveDetails, setleaveDetails] = useState({
        emp_id: emp_id,
        leave_type: '',
        start_date: '',
        end_date: '',
        content_des: ''
    });

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setleaveDetails(prevState => ({
            ...prevState,
            [name]: value
        }));
        console.log(leaveDetails);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsSubmitting(true);
        setErrorMessage('');

        try {
            const company_id = Cookies.get('company_id');
            const payload = { ...leaveDetails, emp_id, company_id };
            const response = await api.post(`hrleave.php`, payload);
            console.log("Data sent successfully:", response.data);
            
            if (response.data.status === 'success') {
                setSuccessMessage('Leave application submitted successfully!');
                setShowSuccessAlert(true);
                setErrorMessage('');
                toggleModalAdd(false);
                
                // Reset form fields
                setleaveDetails({
                    emp_id: emp_id,
                    leave_type: '',
                    start_date: '',
                    end_date: '',
                    content_des: ''
                });
                
                window.location.reload();
            } else {
                setErrorMessage(response.data.message || 'Failed to submit leave application');
                setSuccessMessage('');
            }
        } catch (error) {
            console.error("Error submitting data:", error);
            setErrorMessage('Error submitting leave application. Please try again.');
            setSuccessMessage('');
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleDeleteConfirmation = (confirmed, m_id) => {
        if (confirmed) {
            const fetchData = async () => {
                try {
                    const company_id = Cookies.get('company_id');
                    const response = await api.get(`hrleave.php?del_id=${deleteProjectName}&company_id=${company_id}`);
                    console.log(response.data);
                    
                    // Show success message for deletion
                    setSuccessMessage('Leave application deleted successfully!');
                    setShowSuccessAlert(true);
                    
                    // Refresh the data
                    const fetchLeaveData = async () => {
                        try {
                            const response = await api.get(`hrleave.php?company_id=${company_id}`);
                            if (response.status === 200) {
                                setFilteredData(response.data);
                                setLeaveList(response.data);
                                setDynamo(response.data);
                                setChange(response.data);
                            }
                        } catch (error) {
                            console.error("Error fetching leave data:", error);
                        }
                    };
                    fetchLeaveData();
                } catch (error) {
                    console.error("Error fetching data:", error);
                    setErrorMessage('Failed to delete leave application. Please try again.');
                }
            };
            fetchData();
        }
        // Close the delete confirmation modal
        setShowDeleteConfirmation(false);
    };

    //Pagination Code Goes here Part 2
    const [projectDropdownOpen1, setProjectDropdownOpen1] = useState(false);
    const [entriesToShow, setEntriesToShow] = useState(5);
    const totalPages = Math.ceil(filteredSearchData.length / entriesToShow);

    const toggleProjectDropdown1 = () => {
        setProjectDropdownOpen1(!projectDropdownOpen1);
    };

    const handleEntriesChange = (value) => {
        setEntriesToShow(value === 'All' ? filteredSearchData.length : Number(value));
        setCurrentPage(1);
    };

    const prePage = () => {
        if (currentPage > 1) {
            setCurrentPage(prevPage => prevPage - 1);
        }
    };

    const nextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(prevPage => prevPage + 1);
        }
    };

    const getSerialNumber = (index) => {
        return (currentPage - 1) * entriesToShow + index + 1;
    };

    useEffect(() => {
        if (Array.isArray(change)) {
            setFilteredData(change.slice((currentPage - 1) * entriesToShow, currentPage * entriesToShow));
        } else {
            setFilteredData([]); // Handle case where change is not an array
        }
    }, [entriesToShow, currentPage, change]);

    return (
        <>
            <div className="header bg-gradient-info py-7 py-lg-8">
                <Container fluid>
                    <Row className='mb-5'>
                        <Col className="order-xl-2 mb-5 mb-xl-0 text-left ">
                            <h1>Leave Management Table</h1>
                        </Col>

                        <Col className="order-xl-2 mb-5 mb-xl-0 d-flex ">
                            <Form className="navbar-search  form-inline ml-5 d-none d-md-flex ml-lg-auto ">
                                <FormGroup className="mb-0 ml-6">
                                    <InputGroup className="input-group-alternative">
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText>
                                                <i className="fas fa-search" style={{color: 'black'}}/>
                                            </InputGroupText>
                                        </InputGroupAddon>
                                        <Input
                                            placeholder="Search Leave Type"
                                            type="text"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                        />
                                    </InputGroup>
                                </FormGroup>
                            </Form>
                        </Col>
                    </Row>

                    {errorMessage && (
                        <Row>
                            <Col>
                                <Alert color="danger" className="mb-3">
                                    <i className="fas fa-exclamation-circle mr-2"></i>
                                    {errorMessage}
                                </Alert>
                            </Col>
                        </Row>
                    )}

                    <Row className="mt-5">
                        <Col className="mb-5 mb-xl-0" xl="12">
                            <Card className="" style={{boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)', backgroundColor: '#fff', borderRadius: '15px'}}>
                                <CardHeader className="border-0">
                                    <Row className="align-items-center">
                                        <div className="col">
                                            <h3 className="mb-0">Leave List</h3>

                                            <div className="d-flex justify-content-end align-items-center">
                                                <div className="mr-3">
                                                    <Dropdown isOpen={projectDropdownOpen1} toggle={toggleProjectDropdown1}>
                                                        <DropdownToggle caret>
                                                            Show Entries: {entriesToShow === filteredSearchData.length ? "All" : entriesToShow}
                                                        </DropdownToggle>
                                                        <DropdownMenu>
                                                            <DropdownItem onClick={() => handleEntriesChange(5)}>5</DropdownItem>
                                                            <DropdownItem onClick={() => handleEntriesChange(10)}>10</DropdownItem>
                                                            <DropdownItem onClick={() => handleEntriesChange('All')}>All</DropdownItem>
                                                        </DropdownMenu>
                                                    </Dropdown>
                                                </div>

                                                <Button style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}} onClick={toggleModalAdd}>Apply Leave</Button>

                                            </div>
                                        </div>
                                    </Row>
                                </CardHeader>

                                <Table className="align-items-center table-flush" responsive>
                                    <thead className="thead-light">
                                        <tr>
                                            <th scope='col'>Id</th>
                                            <th scope='col'>Employee Name</th>
                                            <th scope="col">Leave Type</th>
                                            <th scope="col">Start Date</th>
                                            <th scope="col">End Date</th>
                                            <th scope='col'>Status</th>
                                            <th scope='col'>View</th>
                                            <th scope='col'>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredSearchData && Array.isArray(filteredSearchData) ? (
                                            filteredSearchData.length > 0 ? (
                                                filteredSearchData
                                                    .slice((currentPage - 1) * entriesToShow, currentPage * entriesToShow)
                                                    .map((item, index) => (
                                                    <tr key={index}>
                                                        <th scope="row">{getSerialNumber(index)}</th>
                                                        <td>{item.emp_name || "N/A"}</td>
                                                        <td>{item.leave_type}</td>
                                                        <td>{item.start_date}</td>
                                                        <td>{item.end_date}</td>
                                                        <td>
                                                            <Badge
                                                                style={{
                                                                    backgroundColor:
                                                                    (item.status || "").trim().toLowerCase() === "approved"
                                                                    ? "#28a745" // green
                                                                    : ["rejected", "reject"].includes((item.status || "").trim().toLowerCase())
                                                                    ? "#dc3545" // red
                                                                    : "#F7D800", // yellow for pending/others
                                                            color: "black"
                                                                }}
                                                                className="p-2"
                                                            >
                                                                {item.status}
                                                                </Badge>
                                                        </td>
                                                        <td>
                                                            <Link to={`/hr-admin/hr-management/leavetable3/${item.id}`}>  <Tippy content='View Leave Details'><i className="fa-solid fa-eye" ></i></Tippy></Link>
                                                        </td>
                                                        {item && item.emp_id != emp_id ? (
                                                            <td>
                                                                <Dropdown isOpen={dropdownOpen[index]} toggle={() => toggleDropdown(index)}>
                                                                    <DropdownToggle caret>
                                                                        <i className="fas fa-ellipsis-v"></i>
                                                                    </DropdownToggle>
                                                                    <DropdownMenu>
                                                                        <DropdownItem onClick={(e) => handleStatusAction(item.id, "Approved", e)}>Approved</DropdownItem>
                                                                        <DropdownItem onClick={(e) => handleStatusAction(item.id, "Rejected", e)}>Rejected</DropdownItem>
                                                                    </DropdownMenu>
                                                                </Dropdown>
                                                            </td>
                                                        ) : (
                                                            <td>
                                                                <Tippy content='Delete Leave Application'>
                                                                    <button onClick={() => { setDeleteProjectName(item.id); setShowDeleteConfirmation(true) }} className='btn btn-deeppink'>
                                                                        <i class="fa-solid fa-trash text-danger"></i>
                                                                    </button>
                                                                </Tippy>
                                                            </td>
                                                        )}
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="8" style={{ textAlign: 'center' }}>No leave applications found for this project</td>
                                                </tr>
                                            )
                                        ) : (
                                            <tr>
                                                <td colSpan="8" style={{ textAlign: 'center' }}>No leave applications available</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                                <nav className='mt-3'>
                                    <ul className='pagination justify-content-center'>
                                        <li className='page-item'>
                                            <a
                                                href='#'
                                                className='page-link text-primary'
                                                onClick={prePage}
                                                disabled={currentPage === 1}
                                            >
                                                Prev
                                            </a>
                                        </li>
                                        <li className='page-item'>
                                            <a
                                                href='#'
                                                className='page-link text-primary'
                                                onClick={nextPage}
                                                disabled={currentPage === totalPages}
                                            >
                                                Next
                                            </a>
                                        </li>
                                    </ul>
                                </nav>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

            <Modal isOpen={modalAdd} toggle={toggleModalAdd}>
                <ModalHeader toggle={toggleModalAdd}>Add Leave</ModalHeader>
                <Row className='px-3'>
                    <Col md={12}>
                        <FormGroup>
                            <label className="form-control-label" htmlFor="input-status">Leave Type</label>
                            <Input
                                className="form-control-alternative"
                                id="input-status"
                                type="select"
                                name="leave_type"
                                onChange={handleInputChange}
                            >
                                <option value="">Select Leave Type</option>
                                {statusOptions.map(option => (
                                    <option key={option.value} value={option.value}>{option.label}</option>
                                ))}
                            </Input>
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup>
                            <label className="form-control-label" htmlFor="input-starting">Leave Start Date</label>
                            <Input
                                className="form-control-alternative"
                                id="input-starting"
                                type="date"
                                name="start_date"
                                onChange={handleInputChange}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup>
                            <label className="form-control-label" htmlFor="input-ending">Leave End Date</label>
                            <Input
                                className="form-control-alternative"
                                id="input-ending"
                                type="date"
                                name="end_date"
                                onChange={handleInputChange}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={12}>
                        <FormGroup>
                            <label className="form-control-label" htmlFor="input-description">Describe about your condition</label>
                            <textarea
                                className="form-control form-control-alternative"
                                id="input-description"
                                name="content_des"
                                onChange={handleInputChange}
                                style={{ minHeight: '100px', resize: 'vertical' }}
                                placeholder="Please describe your reason for leave..."
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col lg='12' className='text-center mb-2'>
                        <Button 
                            style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}} 
                            type="submit" 
                            onClick={handleSubmit}
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? (
                                <>
                                    <i className="fas fa-spinner fa-spin mr-2"></i>
                                    Submitting...
                                </>
                            ) : (
                                'Submit'
                            )}
                        </Button>
                    </Col>
                </Row>
            </Modal>

            <Modal isOpen={showDeleteConfirmation} toggle={() => setShowDeleteConfirmation(false)}>
                <ModalHeader>Confirm Deletion</ModalHeader>
                <ModalBody>
                    Are you sure you want to delete this leave application?
                </ModalBody>
                <div className="modal-footer">
                    <Button color="danger" onClick={() => handleDeleteConfirmation("confirmed", deleteProjectName)}>Yes</Button>
                    <Button color="secondary" onClick={() => setShowDeleteConfirmation(false)}>No</Button>
                </div>
            </Modal>

            {showSuccessAlert && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
                    justifyContent: 'center', alignItems: 'flex-start', paddingTop: '15%', zIndex: 9999
                }}>
                    <div style={{
                        backgroundColor: '#fff', padding: '30px', borderRadius: '15px',
                        boxShadow: '0 10px 30px rgba(0,0,0,0.3)', textAlign: 'center',
                        maxWidth: '400px', width: '90%', border: '3px solid #d86f89'
                    }}>
                        <div style={{ fontSize: '48px', color: '#d86f89', marginBottom: '20px' }}>✓</div>
                        <h4 style={{ color: '#28a745', marginBottom: '15px' }}>Success!</h4>
                        <p style={{ color: '#333', fontSize: '16px', marginBottom: '20px' }}>{successMessage}</p>
                        <Button
                            style={{
                                backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'white',
                                padding: '10px 25px', borderRadius: '25px'
                            }}
                            onClick={() => {
                                setShowSuccessAlert(false);
                                window.location.reload();
                            }}
                        >OK</Button>
                    </div>
                </div>
            )}
        </>
    );
};

export default Leave3;